"use strict";
import { useTranslation } from "react-i18next";
import { Flex, Text, useMedia } from "ui/src";
import { Wrench } from "ui/src/components/icons/Wrench";
import { useDeviceInsets } from "ui/src/hooks/useDeviceInsets";
import { zIndexes } from "ui/src/theme";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import { TESTNET_MODE_BANNER_HEIGHT } from "features/settings/hooks";
export function TestnetModeBanner(props) {
  const { isTestnetModeEnabled } = useEnabledChains();
  const { t } = useTranslation();
  const media = useMedia();
  const { top } = useDeviceInsets();
  if (!isTestnetModeEnabled) {
    return null;
  }
  return <Flex
    row
    centered
    top={top}
    position={"relative"}
    zIndex={zIndexes.fixed}
    width={"100%"}
    p="$padding12"
    gap="$gap8"
    backgroundColor="$statusSuccess2"
    borderWidth={media.md ? "$spacing1" : "$none"}
    borderBottomWidth="$spacing1"
    height={TESTNET_MODE_BANNER_HEIGHT}
    borderStyle="dashed"
    borderColor="$surface3"
    mb="$spacing16"
    {...props}
    borderRadius="$rounded8"
  >
      <Wrench color="$statusSuccess" size={media.md ? "$icon.16" : "$icon.20"} />
      <Text color="$statusSuccess" variant={media.md ? "body4" : "body3"}>
        {t("home.banner.testnetMode")}
      </Text>
    </Flex>;
}
